<template>
  <div>
    <Form :ref="'form'+current" :model="form" :rules="rules" :label-width="165">
      <Divider orientation="left">加分材料</Divider>
      <Row :gutter="16">
        <Col span="24">
        <List border item-layout="vertical">
          <!-- 职称材料 -->
          <ListItem>
            <ListItemMeta>
              <template #title>
                <li>
                  <Checkbox v-model.trim="form.hasPlusTitle" label="职称材料">职称材料</Checkbox>
                </li>
              </template>
              <!-- @on-change="(val)=>{collapse1=val}"  -->
              <template #description>
                <Collapse v-model.trim="collapse1" v-if="form.hasPlusTitle" :key="form.hasPlusTitle">
                  <Panel class="bonusMaterial_childPage" hide-arrow :name="'collapse1'+index" v-for="(item,index) in form.plusTitleList" :key="'bonusMaterial1'+index">
                    <span class="removeIcon" v-show="form.plusTitleList.length>1" @click="delChild('plusTitleList',index)">
                      <Icon type="md-remove" size="16" color="#ffffff" />
                    </span> 职称材料{{index+1}}
                    <template #content>
                      <Row :gutter="16">
                        <Col span="12">
                        <FormItem :label="'职称'+(index+1)+'名称'" :prop='"plusTitleList["+index+"].title"' :key='"plusTitleList["+index+"].title"' :rules="{required: true, message:'请输入', trigger: 'change'}">
                          <Input v-model.trim="form.plusTitleList[index].title" placeholder="请输入">
                          </Input>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="是否注册类证书" :key='"plusTitleList["+index+"].isRegCert"' :prop='"plusTitleList["+index+"].isRegCert"' :rules="{required: true,type:'boolean', message:'请选择', trigger: 'blur'}">
                          <RadioGroup v-model.trim="form.plusTitleList[index].isRegCert">
                            <Radio :label="true">是</Radio>
                            <Radio :label="false">否</Radio>
                          </RadioGroup>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem :label="'职称证书'+(index+1)" :key='"plusTitleList["+index+"].titleCertGuid"' :prop='"plusTitleList["+index+"].titleCertGuid"' :rules="{required: true, message:'请上传', trigger: 'blur'}">
                          <!-- :prop='"plusTitleList["+index+"].titleCertGuids"' :rules="{required: true, message:'请上传', trigger: 'blur'}" -->
                          <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.plusTitleList[index].titleCertGuidPreview"
                            :ref="'plusTitleList['+index+'].titleCertGuid'" :on-preview="handlePreview" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData"
                            :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusTitleList[${index}].titleCertGuid`)"
                            :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusTitleList[${index}].titleCertGuid`)" :before-upload='(file)=>handleBefore(`plusTitleList[${index}].titleCertGuid`)'
                            :on-format-error="handleFormatError">
                            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
                            <Button icon="ios-camera" @click.stop="openQrCodeUpload(`plusTitleList[${index}].titleCertGuid`)">手机拍照上传</Button>
                          </Upload>
                          <div class="_linkdel" v-for="file in form.plusTitleList[index].titleCertGuidPreview" :key="file.guid">
                            <div class="fileCentent" @click="handlePreview(file)">
                              <Icon :type="file.name | fileType" />
                              {{file.name?file.name:file.fileName}}
                            </div>
                            <div class="fileDel">
                              <Icon type="md-close" @click="handleRemove(file, null, `plusTitleList[${index}].titleCertGuid`)" />
                            </div>
                          </div>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem :label="'聘任表'+(index+1)" :prop='"plusTitleList["+index+"].appointmentFormGuid"' :rules="{required: true, message:'请上传', trigger: 'blur'}">
                          <!-- :key='"plusTitleList["+index+"].appointmentFormGuid"' :prop='"plusTitleList["+index+"].appointmentFormGuid"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                          <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.plusTitleList[index].appointmentFormGuidPreview"
                            :ref="'plusTitleList['+index+'].appointmentFormGuid'" :on-preview="handlePreview" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData"
                            :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusTitleList[${index}].appointmentFormGuid`)"
                            :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusTitleList[${index}].appointmentFormGuid`)" :before-upload='(file)=>handleBefore(`plusTitleList[${index}].appointmentFormGuid`)'
                            :on-format-error="handleFormatError">
                            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
                            <Button icon="ios-camera" @click.stop="openQrCodeUpload(`plusTitleList[${index}].appointmentFormGuid`)">手机拍照上传</Button>
                          </Upload>
                          <div class="_linkdel" v-for="file in form.plusTitleList[index].appointmentFormGuidPreview" :key="file.guid">
                            <div class="fileCentent" @click="handlePreview(file)">
                              <Icon :type="file.name | fileType" />
                              {{file.name?file.name:file.fileName}}
                            </div>
                            <div class="fileDel">
                              <Icon type="md-close" @click="handleRemove(file, null, `plusTitleList[${index}].appointmentFormGuid`)" />
                            </div>
                          </div>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem :label="'评审表/考试表'+(index+1)" :prop='"plusTitleList["+index+"].reviewFormGuid"' :rules="{required: true, message:'请上传', trigger: 'blur'}">
                          <!-- :prop='"plusTitleList["+index+"].reviewFormGuid"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                          <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.plusTitleList[index].reviewFormGuidPreview"
                            :ref="'plusTitleList['+index+'].reviewFormGuid'" :on-preview="handlePreview" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData"
                            :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusTitleList[${index}].reviewFormGuid`)"
                            :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusTitleList[${index}].reviewFormGuid`)" :before-upload='(file)=>handleBefore(`plusTitleList[${index}].reviewFormGuid`)'
                            :on-format-error="handleFormatError">
                            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
                            <Button icon="ios-camera" @click.stop="openQrCodeUpload(`plusTitleList[${index}].reviewFormGuid`)">手机拍照上传</Button>
                          </Upload>
                          <div class="_linkdel" v-for="file in form.plusTitleList[index].reviewFormGuidPreview" :key="file.guid">
                            <div class="fileCentent" @click="handlePreview(file)">
                              <Icon :type="file.name | fileType" />
                              {{file.name?file.name:file.fileName}}
                            </div>
                            <div class="fileDel">
                              <Icon type="md-close" @click="handleRemove(file, null, `plusTitleList[${index}].reviewFormGuid`)" />
                            </div>
                          </div>
                        </FormItem>
                        </Col>
                        <Col span="12" v-show="form.plusTitleList[index].isRegCert===true">
                        <FormItem :label="'注册证书'+(index+1)" :prop='"plusTitleList["+index+"].regCertGuid"' :required="form.plusTitleList[index].isRegCert"
                          :rules="{required: form.plusTitleList[index].isRegCert===true, message:'请上传', trigger: 'blur'}">
                          <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.plusTitleList[index].regCertGuidPreview"
                            :ref="'plusTitleList['+index+'].regCertGuid'" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData" :on-preview="handlePreview"
                            :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusTitleList[${index}].regCertGuid`)"
                            :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusTitleList[${index}].regCertGuid`)" :before-upload='(file)=>handleBefore(`plusTitleList[${index}].regCertGuid`)'
                            :on-format-error="handleFormatError">
                            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
                            <Button icon="ios-camera" @click.stop="openQrCodeUpload(`plusTitleList[${index}].regCertGuid`)">手机拍照上传</Button>
                          </Upload>
                          <div class="_linkdel" v-for="file in form.plusTitleList[index].regCertGuidPreview" :key="file.guid">
                            <div class="fileCentent" @click="handlePreview(file)">
                              <Icon :type="file.name | fileType" />
                              {{file.name?file.name:file.fileName}}
                            </div>
                            <div class="fileDel">
                              <Icon type="md-close" @click="handleRemove(file, null, `plusTitleList[${index}].regCertGuid`)" />
                            </div>
                          </div>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem :label="'职称'+(index+1)+'补充材料'">
                          <!--  :prop='"plusTitleList["+index+"].otherFileGuids"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                          <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.plusTitleList[index].otherFileGuidListPreview"
                            :ref="'plusTitleList['+index+'].otherFileGuidList'" :action="$baseURL+'/common/file/uploadfile'" :on-preview="handlePreview" :data="uploadData"
                            :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusTitleList[${index}].otherFileGuidList`,true)"
                            :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusTitleList[${index}].otherFileGuidList`,true)" :on-format-error="handleFormatError">
                            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
                            <Button icon="ios-camera" @click.stop="openQrCodeUpload(`plusTitleList[${index}].otherFileGuidList`,true)">手机拍照上传</Button>
                          </Upload>
                          <div class="_linkdel" v-for="file in form.plusTitleList[index].otherFileGuidListPreview" :key="file.guid">
                            <div class="fileCentent" @click="handlePreview(file)">
                              <Icon :type="file.name | fileType" />
                              {{file.name?file.name:file.fileName}}
                            </div>
                            <div class="fileDel">
                              <Icon type="md-close" @click="handleRemove(file, null,  `plusTitleList[${index}].otherFileGuidList`,true)" />
                            </div>
                          </div>
                        </FormItem>
                        </Col>
                      </Row>
                    </template>
                  </Panel>
                </Collapse>
              </template>
            </ListItemMeta>
            <!-- <template #action>
            <Button ghost type="primary" v-show="form.hasPlusTitle" @click="addChild('plusTitleList','collapse1')" icon="md-add">添加职称材料</Button>
          </template> -->
          </ListItem>
          <!-- 技能等级材料 -->
          <ListItem>
            <ListItemMeta>
              <template #title>
                <li>
                  <Checkbox v-model.trim="form.hasPlusSkillLevel" label="技能等级材料">技能等级材料</Checkbox>
                </li>
              </template>
              <template #description>
                <Collapse v-model.trim="collapse2" v-if="form.hasPlusSkillLevel" :key="form.hasPlusSkillLevel">
                  <Panel class="bonusMaterial_childPage" hide-arrow :name="'collapse2'+index" v-for="(item,index) in form.plusSkillLevelList" :key="'bonusMaterial'+index">
                    <span class="removeIcon" v-show="form.plusSkillLevelList.length>1" @click="delChild('plusSkillLevelList',index)">
                      <Icon type="md-remove" size="16" color="#ffffff" />
                    </span> 技能等级材料{{index+1}}
                    <template #content>
                      <Row :gutter="16">
                        <Col span="12">
                        <FormItem :label="'技能等级'+(index+1)+'名称'" :prop='"plusSkillLevelList["+index+"].title"' :rules="{required: true, message:'请输入', trigger: 'change'}">
                          <Input v-model.trim="form.plusSkillLevelList[index].title" placeholder="请输入">
                          </Input>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem :label="'技能等级证书'+(index+1)" :prop='"plusSkillLevelList["+index+"].skillLevelCertGuid"' :rules="{required: true, message:'请上传', trigger: 'blur'}">
                          <!-- :prop='"plusSkillLevelList["+index+"].titleCertGuid"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                          <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.plusSkillLevelList[index].skillLevelCertGuidPreview" :on-preview="handlePreview"
                            :ref="'plusSkillLevelList['+index+'].skillLevelCertGuid'" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData"
                            :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusSkillLevelList[${index}].skillLevelCertGuid`)"
                            :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusSkillLevelList[${index}].skillLevelCertGuid`)"
                            :before-upload='(file)=>handleBefore(`plusSkillLevelList[${index}].skillLevelCertGuid`)' :on-format-error="handleFormatError">
                            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
                            <Button icon="ios-camera" @click.stop="openQrCodeUpload(`plusSkillLevelList[${index}].skillLevelCertGuid`)">手机拍照上传</Button>
                          </Upload>
                          <div class="_linkdel" v-for="file in form.plusSkillLevelList[index].skillLevelCertGuidPreview" :key="file.guid">
                            <div class="fileCentent" @click="handlePreview(file)">
                              <Icon :type="file.name | fileType" />
                              {{file.name?file.name:file.fileName}}
                            </div>
                            <div class="fileDel">
                              <Icon type="md-close" @click="handleRemove(file, null, `plusSkillLevelList[${index}].skillLevelCertGuid`)" />
                            </div>
                          </div>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem :label="'技能等级证书'+(index+1)+'补充材料'">
                          <!-- :prop='"plusSkillLevelList["+index+"].otherFileGuids"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                          <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.plusSkillLevelList[index].otherFileGuidListPreview" :on-preview="handlePreview"
                            :action="$baseURL+'/common/file/uploadfile'" :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusSkillLevelList[${index}].otherFileGuidList`,true)"
                            :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusSkillLevelList[${index}].otherFileGuidList`,true)" :on-format-error="handleFormatError">
                            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
                            <Button icon="ios-camera" @click.stop="openQrCodeUpload(`plusSkillLevelList[${index}].otherFileGuidList`,true)">手机拍照上传</Button>
                          </Upload>
                          <div class="_linkdel" v-for="file in form.plusSkillLevelList[index].otherFileGuidListPreview" :key="file.guid">
                            <div class="fileCentent" @click="handlePreview(file)">
                              <Icon :type="file.name | fileType" />
                              {{file.name?file.name:file.fileName}}
                            </div>
                            <div class="fileDel">
                              <Icon type="md-close" @click="handleRemove(file, null, `plusSkillLevelList[${index}].otherFileGuidList`,true)" />
                            </div>
                          </div>
                        </FormItem>
                        </Col>
                      </Row>
                    </template>
                  </Panel>
                </Collapse>
              </template>
            </ListItemMeta>
            <!-- <template #action>
            <Button ghost type="primary" v-show="form.hasPlusSkillLevel" @click="addChild('plusSkillLevelList','collapse2')" icon="md-add">添加技能等级材料</Button>
          </template> -->
          </ListItem>
          <!--表彰奖励材料  -->
          <ListItem>
            <ListItemMeta>
              <template #title>
                <li>
                  <Checkbox v-model.trim="form.hasPlusRecognitionAward" label="表彰奖励材料">表彰奖励材料</Checkbox>
                </li>
              </template>
              <template #description>
                <Collapse v-model.trim="collapse3" v-if="form.hasPlusRecognitionAward" :key="form.hasPlusRecognitionAward">
                  <Panel class="bonusMaterial_childPage" hide-arrow :name="'collapse3'+index" v-for="(item,index) in form.plusRecognitionAwardList" :key="'bonusMaterial3'+index">
                    <span class="removeIcon" v-show="form.plusRecognitionAwardList.length>1" @click="delChild('plusRecognitionAwardList',index)">
                      <Icon type="md-remove" size="16" color="#ffffff" />
                    </span> 表彰奖励材料{{index+1}}
                    <template #content>
                      <Row :gutter="16">
                        <Col span="12">
                        <FormItem :label="'表彰奖励'+(index+1)+'名称'" :prop='"plusRecognitionAwardList["+index+"].title"' :rules="{required: true, message:'请输入', trigger: 'change'}">
                          <Input v-model.trim="form.plusRecognitionAwardList[index].title" placeholder="请输入">
                          </Input>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem :label="'表彰奖励'+(index+1)+'材料'" :prop='"plusRecognitionAwardList["+index+"].recognitionAwardGuid"' :rules="{required: true, message:'请上传', trigger: 'blur'}">
                          <!-- :prop='"plusRecognitionAwardList["+index+"].titleCertGuid"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                          <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.plusRecognitionAwardList[index].recognitionAwardGuidPreview"
                            :on-preview="handlePreview" :ref="'plusRecognitionAwardList['+index+'].recognitionAwardGuid'" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData"
                            :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusRecognitionAwardList[${index}].recognitionAwardGuid`)"
                            :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusRecognitionAwardList[${index}].recognitionAwardGuid`)"
                            :before-upload='(file)=>handleBefore(`plusRecognitionAwardList[${index}].recognitionAwardGuid`)' :on-format-error="handleFormatError">
                            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
                            <Button icon="ios-camera" @click.stop="openQrCodeUpload(`plusRecognitionAwardList[${index}].recognitionAwardGuid`)">手机拍照上传</Button>
                          </Upload>
                          <div class="_linkdel" v-for="file in form.plusRecognitionAwardList[index].recognitionAwardGuidPreview" :key="file.guid">
                            <div class="fileCentent" @click="handlePreview(file)">
                              <Icon :type="file.name | fileType" />
                              {{file.name?file.name:file.fileName}}
                            </div>
                            <div class="fileDel">
                              <Icon type="md-close" @click="handleRemove(file, null, `plusRecognitionAwardList[${index}].recognitionAwardGuid`)" />
                            </div>
                          </div>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem :label="'表彰奖励'+(index+1)+'补充材料'">
                          <!--  :prop='"plusRecognitionAwardList["+index+"].otherFileGuids"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                          <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.plusRecognitionAwardList[index].otherFileGuidListPreview"
                            :on-preview="handlePreview" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusRecognitionAwardList[${index}].otherFileGuidList`,true)"
                            :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusRecognitionAwardList[${index}].otherFileGuidList`,true)" :on-format-error="handleFormatError">
                            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
                            <Button icon="ios-camera" @click.stop="openQrCodeUpload(`plusRecognitionAwardList[${index}].otherFileGuidList`,true)">手机拍照上传</Button>
                          </Upload>
                          <div class="_linkdel" v-for="file in form.plusRecognitionAwardList[index].otherFileGuidListPreview" :key="file.guid">
                            <div class="fileCentent" @click="handlePreview(file)">
                              <Icon :type="file.name | fileType" />
                              {{file.name?file.name:file.fileName}}
                            </div>
                            <div class="fileDel">
                              <Icon type="md-close" @click="handleRemove(file, null, `plusRecognitionAwardList[${index}].otherFileGuidList`,true)" />
                            </div>
                          </div>
                        </FormItem>
                        </Col>
                      </Row>
                    </template>
                  </Panel>
                </Collapse>
              </template>
            </ListItemMeta>
            <!-- <template #action>
            <Button ghost type="primary" v-show="form.hasPlusRecognitionAward" @click="addChild('plusRecognitionAwardList','collapse3')" icon="md-add">添加表彰奖励材料</Button>
          </template> -->
          </ListItem>
          <!-- 投资纳税带动本地就业材料 -->
          <ListItem>
            <ListItemMeta>
              <template #title>
                <li>
                  <Checkbox v-model.trim="form.hasPlusInvestmentTaxationDrivingLocalEmployment" label="投资纳税带动本地就业材料">投资纳税带动本地就业材料</Checkbox>
                </li>
              </template>
              <template #description>
                <Collapse v-model.trim="collapse4" v-if="form.hasPlusInvestmentTaxationDrivingLocalEmployment" :key="form.hasPlusInvestmentTaxationDrivingLocalEmployment">
                  <Panel class="bonusMaterial_childPage" hide-arrow :name="'collapse4'+index" v-for="(item,index) in form.plusInvestmentTaxationDrivingLocalEmploymentList" :key="'bonusMaterial4'+index">
                    <span class="removeIcon" v-show="form.plusInvestmentTaxationDrivingLocalEmploymentList.length>1" @click="delChild('plusInvestmentTaxationDrivingLocalEmploymentList',index)">
                      <Icon type="md-remove" size="16" color="#ffffff" />
                    </span> 投资单位{{index+1}}
                    <template #content>
                      <Row :gutter="16">
                        <Col span="12">
                        <FormItem :label="'投资单位'+(index+1)+'名称'" :prop='"plusInvestmentTaxationDrivingLocalEmploymentList["+index+"].enterpriseName"' :rules="{required: true, message:'请输入', trigger: 'change'}">
                          <Input v-model.trim="form.plusInvestmentTaxationDrivingLocalEmploymentList[index].enterpriseName" placeholder="请输入">
                          </Input>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem :label="'投资单位'+(index+1)+'验资报告'" :prop='"plusInvestmentTaxationDrivingLocalEmploymentList["+index+"].capitalVerificationReportGuid"' :rules="{required: true, message:'请上传', trigger: 'blur'}">
                          <!--  :prop='"plusInvestmentTaxationDrivingLocalEmploymentList["+index+"].titleCertGuid"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                          <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat"
                            :default-file-list="form.plusInvestmentTaxationDrivingLocalEmploymentList[index].capitalVerificationReportGuidPreview" :on-preview="handlePreview"
                            :ref="'plusInvestmentTaxationDrivingLocalEmploymentList['+index+'].capitalVerificationReportGuid'" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData"
                            :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusInvestmentTaxationDrivingLocalEmploymentList[${index}].capitalVerificationReportGuid`)"
                            :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusInvestmentTaxationDrivingLocalEmploymentList[${index}].capitalVerificationReportGuid`)"
                            :before-upload='(file)=>handleBefore(`plusInvestmentTaxationDrivingLocalEmploymentList[${index}].capitalVerificationReportGuid`)' :on-format-error="handleFormatError">
                            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
                            <Button icon="ios-camera" @click.stop="openQrCodeUpload(`plusInvestmentTaxationDrivingLocalEmploymentList[${index}].capitalVerificationReportGuid`)">手机拍照上传</Button>
                          </Upload>
                          <div class="_linkdel" v-for="file in form.plusInvestmentTaxationDrivingLocalEmploymentList[index].capitalVerificationReportGuidPreview" :key="file.guid">
                            <div class="fileCentent" @click="handlePreview(file)">
                              <Icon :type="file.name | fileType" />
                              {{file.name?file.name:file.fileName}}
                            </div>
                            <div class="fileDel">
                              <Icon type="md-close" @click="handleRemove(file, null, `plusInvestmentTaxationDrivingLocalEmploymentList[${index}].capitalVerificationReportGuid`)" />
                            </div>
                          </div>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem :label="'投资单位'+(index+1)+'工伤档案机读材料'" :prop='"plusInvestmentTaxationDrivingLocalEmploymentList["+index+"].businessArchivesMachineReadGuid"' :rules="{required: true, message:'请上传', trigger: 'blur'}">
                          <!-- :prop='"plusInvestmentTaxationDrivingLocalEmploymentList["+index+"].businessArchivesMachineReadGuid"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                          <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat"
                            :default-file-list="form.plusInvestmentTaxationDrivingLocalEmploymentList[index].businessArchivesMachineReadGuidPreview" :on-preview="handlePreview"
                            :ref="'plusInvestmentTaxationDrivingLocalEmploymentList['+index+'].businessArchivesMachineReadGuid'" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData"
                            :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusInvestmentTaxationDrivingLocalEmploymentList[${index}].businessArchivesMachineReadGuid`)"
                            :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusInvestmentTaxationDrivingLocalEmploymentList[${index}].businessArchivesMachineReadGuid`)"
                            :before-upload='(file)=>handleBefore(`plusInvestmentTaxationDrivingLocalEmploymentList[${index}].businessArchivesMachineReadGuid`)' :on-format-error="handleFormatError">
                            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
                            <Button icon="ios-camera" @click.stop="openQrCodeUpload(`plusInvestmentTaxationDrivingLocalEmploymentList[${index}].businessArchivesMachineReadGuid`)">手机拍照上传</Button>
                          </Upload>
                          <div class="_linkdel" v-for="file in form.plusInvestmentTaxationDrivingLocalEmploymentList[index].businessArchivesMachineReadGuidPreview" :key="file.guid">
                            <div class="fileCentent" @click="handlePreview(file)">
                              <Icon :type="file.name | fileType" />
                              {{file.name?file.name:file.fileName}}
                            </div>
                            <div class="fileDel">
                              <Icon type="md-close" @click="handleRemove(file, null, `plusInvestmentTaxationDrivingLocalEmploymentList[${index}].businessArchivesMachineReadGuid`)" />
                            </div>
                          </div>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem :label="'投资单位'+(index+1)+'近三年税单'" :prop='"plusInvestmentTaxationDrivingLocalEmploymentList["+index+"].taxOfLastThreeYearGuid"' :rules="{required: true, message:'请上传', trigger: 'blur'}">
                          <!--  :prop='"plusInvestmentTaxationDrivingLocalEmploymentList["+index+"].year3guid"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                          <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat"
                            :default-file-list="form.plusInvestmentTaxationDrivingLocalEmploymentList[index].taxOfLastThreeYearGuidPreview" :on-preview="handlePreview"
                            :ref="'plusInvestmentTaxationDrivingLocalEmploymentList['+index+'].taxOfLastThreeYearGuid'" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData"
                            :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusInvestmentTaxationDrivingLocalEmploymentList[${index}].taxOfLastThreeYearGuid`)"
                            :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusInvestmentTaxationDrivingLocalEmploymentList[${index}].taxOfLastThreeYearGuid`)"
                            :before-upload='(file)=>handleBefore(`plusInvestmentTaxationDrivingLocalEmploymentList[${index}].taxOfLastThreeYearGuid`)' :on-format-error="handleFormatError">
                            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
                            <Button icon="ios-camera" @click.stop="openQrCodeUpload(`plusInvestmentTaxationDrivingLocalEmploymentList[${index}].taxOfLastThreeYearGuidPreview`)">手机拍照上传</Button>
                          </Upload>
                          <div class="_linkdel" v-for="file in form.plusInvestmentTaxationDrivingLocalEmploymentList[index].taxOfLastThreeYearGuidPreview" :key="file.guid">
                            <div class="fileCentent" @click="handlePreview(file)">
                              <Icon :type="file.name | fileType" />
                              {{file.name?file.name:file.fileName}}
                            </div>
                            <div class="fileDel">
                              <Icon type="md-close" @click="handleRemove(file, null, `plusInvestmentTaxationDrivingLocalEmploymentList[${index}].taxOfLastThreeYearGuid`)" />
                            </div>
                          </div>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="上传材料">
                          <!-- :prop='"plusInvestmentTaxationDrivingLocalEmploymentList["+index+"].uptype"' :rules="{required: false, message:'请选择', trigger: 'blur'}" -->
                          <RadioGroup v-model.trim="form.plusInvestmentTaxationDrivingLocalEmploymentList[index].uploadMaterialType">
                            <!-- <Radio label="连续三年本市税单明细>=10万证明材料">连续三年本市税单明细>=10万证明材料</Radio>
                          <Radio label="连续三年聘用本市户籍人员>=10证明材料(连续缴纳社保>=6个月)">连续三年聘用本市户籍人员>=10证明材料(连续缴纳社保>=6个月)</Radio> -->
                            <Radio :label="value" v-for="{text,value} in $store.state.materiaBasicData.plusITDLEUploadMaterialType" :key="value">{{text}}</Radio>
                          </RadioGroup>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem :label="'投资单位'+(index+1)+'近三年税单明细'" :prop='"plusInvestmentTaxationDrivingLocalEmploymentList["+index+"].taxDetailOfLastThreeYearGuid"' :rules="{required: true, message:'请上传', trigger: 'blur'}">
                          <!-- :prop='"plusInvestmentTaxationDrivingLocalEmploymentList["+index+"].taxDetailOfLastThreeYearGuid"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                          <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat"
                            :default-file-list="form.plusInvestmentTaxationDrivingLocalEmploymentList[index].taxDetailOfLastThreeYearGuidPreview" :on-preview="handlePreview"
                            :ref="'plusInvestmentTaxationDrivingLocalEmploymentList['+index+'].taxDetailOfLastThreeYearGuid'" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData"
                            :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusInvestmentTaxationDrivingLocalEmploymentList[${index}].taxDetailOfLastThreeYearGuid`)"
                            :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusInvestmentTaxationDrivingLocalEmploymentList[${index}].taxDetailOfLastThreeYearGuid`)"
                            :before-upload='(file)=>handleBefore(`plusInvestmentTaxationDrivingLocalEmploymentList[${index}].taxDetailOfLastThreeYearGuid`)' :on-format-error="handleFormatError">
                            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
                            <Button icon="ios-camera" @click.stop="openQrCodeUpload(`plusInvestmentTaxationDrivingLocalEmploymentList[${index}].taxDetailOfLastThreeYearGuid`)">手机拍照上传</Button>
                          </Upload>
                          <div class="_linkdel" v-for="file in form.plusInvestmentTaxationDrivingLocalEmploymentList[index].taxDetailOfLastThreeYearGuidPreview" :key="file.guid">
                            <div class="fileCentent" @click="handlePreview(file)">
                              <Icon :type="file.name | fileType" />
                              {{file.name?file.name:file.fileName}}
                            </div>
                            <div class="fileDel">
                              <Icon type="md-close" @click="handleRemove(file, null, `plusInvestmentTaxationDrivingLocalEmploymentList[${index}].taxDetailOfLastThreeYearGuid`)" />
                            </div>
                          </div>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem :label="'投资单位'+(index+1)+'近三年补充材料'">
                          <!-- :prop='"plusInvestmentTaxationDrivingLocalEmploymentList["+index+"].year3guidOther"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                          <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.plusInvestmentTaxationDrivingLocalEmploymentList[index].otherFileGuidListPreview"
                            :on-preview="handlePreview" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData"
                            :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusInvestmentTaxationDrivingLocalEmploymentList[${index}].otherFileGuidList`,true)"
                            :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusInvestmentTaxationDrivingLocalEmploymentList[${index}].otherFileGuidList`,true)" :on-format-error="handleFormatError">
                            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
                            <Button icon="ios-camera" @click.stop="openQrCodeUpload(`plusInvestmentTaxationDrivingLocalEmploymentList[${index}].otherFileGuidList`,true)">手机拍照上传</Button>
                          </Upload>
                          <div class="_linkdel" v-for="file in form.plusInvestmentTaxationDrivingLocalEmploymentList[index].otherFileGuidListPreview" :key="file.guid">
                            <div class="fileCentent" @click="handlePreview(file)">
                              <Icon :type="file.name | fileType" />
                              {{file.name?file.name:file.fileName}}
                            </div>
                            <div class="fileDel">
                              <Icon type="md-close" @click="handleRemove(file, null, `plusInvestmentTaxationDrivingLocalEmploymentList[${index}].otherFileGuidList`,true)" />
                            </div>
                          </div>
                        </FormItem>
                        </Col>
                      </Row>
                    </template>
                  </Panel>
                </Collapse>
              </template>
            </ListItemMeta>
            <!-- <template #action>
            <Button ghost type="primary" v-show="form.hasPlusInvestmentTaxationDrivingLocalEmployment" @click="addChild('plusInvestmentTaxationDrivingLocalEmploymentList','collapse4')" icon="md-add">添加投资单位材料</Button>
          </template> -->
          </ListItem>
          <!--孵化器材料  -->
          <ListItem>
            <ListItemMeta>
              <template #title>
                <li>
                  <Checkbox v-model.trim="form.hasPlusIncubatorMaterial" label="孵化器材料">孵化器材料</Checkbox>
                </li>
              </template>
              <template #description>
                <Collapse v-model.trim="collapse5" v-if="form.hasPlusIncubatorMaterial" :key="form.hasPlusIncubatorMaterial">
                  <Panel class="bonusMaterial_childPage" hide-arrow :name="'collapse5'+index" v-for="(item,index) in form.plusIncubatorMaterialList" :key="'bonusMaterial5'+index">
                    <span class="removeIcon" v-show="form.plusIncubatorMaterialList.length>1" @click="delChild('plusIncubatorMaterialList',index)">
                      <Icon type="md-remove" size="16" color="#ffffff" />
                    </span> 孵化器{{index+1}}
                    <template #content>
                      <Row :gutter="16">
                        <Col span="12">
                        <FormItem :label="'孵化器'+(index+1)+'名称'" :prop='"plusIncubatorMaterialList["+index+"].title"' :rules="{required: true, message:'请输入', trigger: 'change'}">
                          <Input v-model.trim.trim="form.plusIncubatorMaterialList[index].title" placeholder="请输入">
                          </Input>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem :label="'孵化器'+(index+1)+'孵化协议'" :prop='"plusIncubatorMaterialList["+index+"].incubationProtocolGuid"' :rules="{required: true, message:'请上传', trigger: 'blur'}">
                          <!--  :prop='"plusIncubatorMaterialList["+index+"].incubationProtocolGuid"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                          <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.plusIncubatorMaterialList[index].incubationProtocolGuidPreview"
                            :on-preview="handlePreview" :ref="'plusIncubatorMaterialList['+index+'].incubationProtocolGuid'" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData"
                            :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusIncubatorMaterialList[${index}].incubationProtocolGuid`)"
                            :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusIncubatorMaterialList[${index}].incubationProtocolGuid`)"
                            :before-upload='(file)=>handleBefore(`plusIncubatorMaterialList[${index}].incubationProtocolGuid`)' :on-format-error="handleFormatError">
                            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
                            <Button icon="ios-camera" @click.stop="openQrCodeUpload(`plusIncubatorMaterialList[${index}].incubationProtocolGuid`)">手机拍照上传</Button>
                          </Upload>
                          <div class="_linkdel" v-for="file in form.plusIncubatorMaterialList[index].incubationProtocolGuidPreview" :key="file.guid">
                            <div class="fileCentent" @click="handlePreview(file)">
                              <Icon :type="file.name | fileType" />
                              {{file.name?file.name:file.fileName}}
                            </div>
                            <div class="fileDel">
                              <Icon type="md-close" @click="handleRemove(file, null, `plusIncubatorMaterialList[${index}].incubationProtocolGuid`)" />
                            </div>
                          </div>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem :label="'孵化器'+(index+1)+'项目合同'" :prop='"plusIncubatorMaterialList["+index+"].projectContractGuid"' :rules="{required: true, message:'请上传', trigger: 'blur'}">
                          <!-- :prop='"plusIncubatorMaterialList["+index+"].projectContractGuid"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                          <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.plusIncubatorMaterialList[index].projectContractGuidPreview"
                            :on-preview="handlePreview" :ref="'plusIncubatorMaterialList['+index+'].projectContractGuid'" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData"
                            :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusIncubatorMaterialList[${index}].projectContractGuid`)"
                            :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusIncubatorMaterialList[${index}].projectContractGuid`)"
                            :before-upload='(file)=>handleBefore(`plusIncubatorMaterialList[${index}].projectContractGuid`)' :on-format-error="handleFormatError">
                            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
                            <Button icon="ios-camera" @click.stop="openQrCodeUpload(`plusIncubatorMaterialList[${index}].projectContractGuid`)">手机拍照上传</Button>
                          </Upload>
                          <div class="_linkdel" v-for="file in form.plusIncubatorMaterialList[index].projectContractGuidPreview" :key="file.guid">
                            <div class="fileCentent" @click="handlePreview(file)">
                              <Icon :type="file.name | fileType" />
                              {{file.name?file.name:file.fileName}}
                            </div>
                            <div class="fileDel">
                              <Icon type="md-close" @click="handleRemove(file, null, `plusIncubatorMaterialList[${index}].projectContractGuid`)" />
                            </div>
                          </div>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem :label="'孵化器'+(index+1)+'工商档案机读材料'" :prop='"plusIncubatorMaterialList["+index+"].businessArchivesMachineReadGuid"' :rules="{required: true, message:'请上传', trigger: 'blur'}">
                          <!--  :prop='"plusIncubatorMaterialList["+index+"].gsdajdcl"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                          <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.plusIncubatorMaterialList[index].businessArchivesMachineReadGuidPreview"
                            :on-preview="handlePreview" :ref="'plusIncubatorMaterialList['+index+'].businessArchivesMachineReadGuid'" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData"
                            :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusIncubatorMaterialList[${index}].businessArchivesMachineReadGuid`,)"
                            :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusIncubatorMaterialList[${index}].businessArchivesMachineReadGuid`)"
                            :before-upload='(file)=>handleBefore(`plusIncubatorMaterialList[${index}].businessArchivesMachineReadGuid`)' :on-format-error="handleFormatError">
                            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
                            <Button icon="ios-camera" @click.stop="openQrCodeUpload(`plusIncubatorMaterialList[${index}].businessArchivesMachineReadGuid`)">手机拍照上传</Button>
                          </Upload>
                          <div class="_linkdel" v-for="file in form.plusIncubatorMaterialList[index].businessArchivesMachineReadGuidPreview" :key="file.guid">
                            <div class="fileCentent" @click="handlePreview(file)">
                              <Icon :type="file.name | fileType" />
                              {{file.name?file.name:file.fileName}}
                            </div>
                            <div class="fileDel">
                              <Icon type="md-close" @click="handleRemove(file, null, `plusIncubatorMaterialList[${index}].businessArchivesMachineReadGuid`)" />
                            </div>
                          </div>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem :label="'孵化器'+(index+1)+'资金到位证明材料'" :prop='"plusIncubatorMaterialList["+index+"].proofOfFundsGuid"' :rules="{required: true, message:'请上传', trigger: 'blur'}">
                          <!--  :prop='"plusIncubatorMaterialList["+index+"].zjdwda"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                          <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.plusIncubatorMaterialList[index].proofOfFundsGuidPreview"
                            :on-preview="handlePreview" :ref="'plusIncubatorMaterialList['+index+'].proofOfFundsGuid'" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData"
                            :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusIncubatorMaterialList[${index}].proofOfFundsGuid`)"
                            :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusIncubatorMaterialList[${index}].proofOfFundsGuid`)"
                            :before-upload='(file)=>handleBefore(`plusIncubatorMaterialList[${index}].proofOfFundsGuid`)' :on-format-error="handleFormatError">
                            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
                            <Button icon="ios-camera" @click.stop="openQrCodeUpload(`plusIncubatorMaterialList[${index}].proofOfFundsGuid`)">手机拍照上传</Button>
                          </Upload>
                          <div class="_linkdel" v-for="file in form.plusIncubatorMaterialList[index].proofOfFundsGuidPreview" :key="file.guid">
                            <div class="fileCentent" @click="handlePreview(file)">
                              <Icon :type="file.name | fileType" />
                              {{file.name?file.name:file.fileName}}
                            </div>
                            <div class="fileDel">
                              <Icon type="md-close" @click="handleRemove(file, null, `plusIncubatorMaterialList[${index}].proofOfFundsGuid`)" />
                            </div>
                          </div>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem :label="'孵化器'+(index+1)+'补充材料'">
                          <!--  :prop='"plusIncubatorMaterialList["+index+"].otherFileGuids"' :rules="{required: false, message:'请上传', trigger: 'blur'}" -->
                          <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.plusIncubatorMaterialList[index].otherFileGuidListPreview"
                            :on-preview="handlePreview" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData"
                            :on-remove="(file, fileList)=>handleRemove(file, fileList, `plusIncubatorMaterialList[${index}].otherFileGuidList`,true)"
                            :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,`plusIncubatorMaterialList[${index}].otherFileGuidList`,true)" :on-format-error="handleFormatError">
                            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
                            <Button icon="ios-camera" @click.stop="openQrCodeUpload(`plusIncubatorMaterialList[${index}].otherFileGuidList`,true)">手机拍照上传</Button>
                          </Upload>
                          <div class="_linkdel" v-for="file in form.plusIncubatorMaterialList[index].otherFileGuidListPreview" :key="file.guid">
                            <div class="fileCentent" @click="handlePreview(file)">
                              <Icon :type="file.name | fileType" />
                              {{file.name?file.name:file.fileName}}
                            </div>
                            <div class="fileDel">
                              <Icon type="md-close" @click="handleRemove(file, null, `plusIncubatorMaterialList[${index}].otherFileGuidList`,true)" />
                            </div>
                          </div>
                        </FormItem>
                        </Col>
                      </Row>
                    </template>
                  </Panel>
                </Collapse>
              </template>
            </ListItemMeta>
            <!-- <template #action>
            <Button ghost type="primary" v-show="form.hasPlusIncubatorMaterial" @click="addChild('plusIncubatorMaterialList','collapse5')" icon="md-add">添加孵化器材料</Button>
          </template> -->
          </ListItem>
        </List>
        </Col>

      </Row>

      <div class="bom_btn">
        <div>
          <Button @click="next(null,(current_index-1))">上一步</Button>
          <Button type="warning" @click="submitStore()">暂存</Button>
          <Button type="primary" @click="next('form'+current)">下一步</Button>
        </div>
      </div>
    </Form>
    <Modal title="请人事使用微信扫码核验身份" v-model="QRshow" :closable="false" :mask-closable="false">
      <template #header>
        <p>
          <img src="../../../../assets/images/weixin.png" class="QRtitle">
          <span>请人事使用微信扫码核验身份</span>
        </p>
      </template>

      <div class="QRcode">
        <img :src="'data:image/png;base64,'+QRcode" alt="">
      </div>
      <Spin size="large" fix v-if="loading"></Spin>
      <template #footer>
        <Button @click="colseQR()" style="margin-right: 5px">关闭</Button>
      </template>
    </Modal>
  </div>
</template>
<script>
export default {
  props: { form: { type: Object }, current: { type: Number } },
  data() {
    return {
      format: ['jpg', 'png', 'jpeg'],
      accept: 'image/*',
      collapse1: ['collapse10'],
      collapse2: ['collapse20'],
      collapse3: ['collapse30'],
      collapse4: ['collapse40'],
      collapse5: ['collapse50'],
      count: 0, //操作
      uploadData: {},
      key: null,
      QRshow: false,
      QRcode: '',
      loading: false,
      timer: null,
      appInfoDataType: this.$store.state.appInfoDataType,
      current_index: this.current,
      rules: {},
      selectList: [
        { name: '是', value: 1 },
        { name: '否', value: 0 },
      ],
    }
  },
  methods: {
    //下一步
    next(name, val) {
      let _this = this
      //上一步
      if (name === null) {
        // this.$emit('next', val)

        if (this.form.hasEducation) {
          if (this.form.isZSB) {
            _this.$emit('next', _this.appInfoDataType['专科学历信息'])
            return
          }
          _this.$emit('next', _this.appInfoDataType['学历信息'])
          return
        }
        if (this.form.isChildrenEnjoyTreatment) {
          _this.$emit('next', _this.appInfoDataType['子女信息'])
          return
        }
        if (
          this.form.applicantMaritalStatus == this.$store.state.maritalStatusSet['初婚'] ||
          this.form.applicantMaritalStatus == this.$store.state.maritalStatusSet['再婚']
        ) {
          _this.$emit('next', _this.appInfoDataType['配偶信息'])
          return
        }
        if (
          this.form.applicantMaritalStatus == this.$store.state.maritalStatusSet['离异'] ||
          this.form.applicantMaritalStatus == this.$store.state.maritalStatusSet['丧偶']
        ) {
          _this.$emit('next', _this.appInfoDataType['申请人婚姻信息'])
          return
        }
        _this.$emit('next', _this.appInfoDataType['申请人基本信息'])

        return
      }
      //下一步
      this.$refs[name].validate(async (valid) => {
        if (!valid) {
          this.$Message.error('请将信息填写完整')
          return
        }
        await _this.$emit('submit', '/api/services/app/JZZJFApi/SaveAppPlusInfo', 0)
        if (
          this.$store.state.isPerson == false &&
          this.form.isPersonalInfoChanged == true &&
          this.form.personId
        ) {
          //个人提交到企业后,企业修改时,有曾用名信息时，企业不弹出提示,直接到下一步（isPerson当前登录人是否为个人，isPersonalInfoChanged是否有曾用名信息，personId个人id（不为null时表示个人提交的
          this.$emit('next', _this.appInfoDataType['个人信息变更'], null, true)
        } else {
        }
        this.$Modal.confirm({
          title: '请确认',
          content: `<p>申请人是否有曾用名或修改过身份证证件号？</p>`,
          okText: '否',
          cancelText: '是',
          onOk: () => {
            // 否 直接提交
            // this.$emit('submit', '/api/services/app/JZZJFApi/SubmitApplication', 1, '提交成功')
            // this.checkUserOpen()
            this.$emit('next', _this.appInfoDataType['全部'], null, false)
          },
          onCancel: () => {
            //是，个人信息变更
            this.$emit('next', _this.appInfoDataType['个人信息变更'], null, true)
          },
        })
      })
    },
    submit(name, type) {
      //type==true时暂存
      let _this = this
      this.$refs[name].validate((valid) => {
        if (!valid) {
          this.$Message.error('请将信息填写完整')
          return
        }
        this.$Modal.confirm({
          title: '请确认',
          content: `<p>是否提交信息</p>`,
          okText: '是',
          cancelText: '否',
          onOk: () => {
            _this.$emit('submit')
          },
        })
      })
    },
    //关闭核验经办人弹窗
    colseQR() {
      this.QRshow = false
      clearTimeout(this.timer)
      this.timer = null
    },

    // 打开核验经办人弹窗获取二维码
    async checkUserOpen() {
      this.QRshow = true
      this.loading = true

      this.key = this.form.guid + '|' + new Date().getTime()
      let { data } = await this.$Ajax.get(
        '/api/services/app/JZZJFApi/GetCheckApplicationQR?key=' + this.key
      )
      // let { data } = await this.$Ajax.get(
      //   '/api/services/app/JZZJFApi/GetCheckApplicationQR?guid=' + this.form.guid
      // )
      this.QRcode = data.result.qrBase64String
      this.loading = false
      this.checkUser(data.result.contextId)
    },
    // 核验经办人 获取个人信息轮询
    checkUser(contextId) {
      let _this = this
      const poll = async () => {
        let { data } = await this.$Ajax.get(`/api/services/app/JZZJFApi/CheckApplicationResult`, {
          params: { contextId },
        })
        if (data.result.success) {
          // _this.bindUserColse()
          _this.colseQR()
          // this.$Modal.confirm({
          //   title: '提示',
          //   content: '<p>确认提交申请？</p>',
          //   okText: '是',
          //   cancelText: '否',
          //   onOk: async () => {
          // 是 直接提交
          try {
            this.form.isPlusMaterialsUploadComplete = true
            await this.$emit(
              'submit',
              '/api/services/app/JZZJFApi/SubmitApplication',
              1,
              '提交成功'
            )
          } catch (error) {
            _this.$Message.error({
              content: '操作失败',
              background: true,
              duration: 6,
            })
          }
          //   },
          //   onCancel: () => {
          //   },
          // })
        } else {
          _this.timer = setTimeout(poll, 2500)
        }
      }
      poll()
    },
    async submitStore() {
      this.form.isPlusMaterialsUploadComplete = false
      await this.$emit(
        'submit',
        '/api/services/app/JZZJFApi/TempSaveAppPlusInfo',
        false,
        '暂存成功'
      )
    },
    addChild(property, collapse_index) {
      this[collapse_index].push(collapse_index + this[collapse_index].length)
      this.$emit('addChild', property, collapse_index)
    },
    delChild(property, index) {
      this.$emit('delChild', property, index)
    },
    openQrCodeUpload(property, isArray, isReadInfo, readIdInfoAfterToView) {
      this.$emit('openQrCodeUpload', property, isArray, isReadInfo, readIdInfoAfterToView)
    },
    //移除文件
    async handleRemove(file, fileList, property, isArray) {
      this.$emit('handleRemove', file, fileList, property, isArray)
    },
    //文件上传成功
    handleSuccess(response, file, fileList, property, isArray) {
      this.$emit('handleSuccess', response, file, fileList, property, isArray)
      this.$forceUpdate()
      this.$refs['form' + this.current].validateField(property)
    },
    //文件格式错误
    handleFormatError(file) {
      this.$emit('handleFormatError', file)
    },
    //上传前 用于单个上传清空上传列表
    handleBefore(property) {
      //不为数组时传一个删一个列表
      try {
        this.$refs[property][0].clearFiles()
      } catch (error) {}
    },

    //文件预览
    handlePreview(file) {
      this.$emit('handlePreview', file)
    },
  },
}
</script>